module.exports = __webpack_public_path__ + "img/3.3_Russian_road_sign.a21a4824.svg";